// A paginação da plataforma: o intervalo exibido ("1 - 40 de N") e as setas. Os props
// opcionais são ADITIVOS — quem não os passa tem exatamente o que tinha:
//   - `disableBack`/`disableForward`: as setas ficam indisponíveis nos limites;
//   - `pageCount`: informa também "Página X de Y" (o intervalo sozinho não diz quantas
//     páginas existem).
// As setas ganham nome acessível ("Página anterior"/"Próxima página"): eram botões só de ícone.
const Pagination = ({
  currentPage,
  count,
  goBack,
  goForward,
  perPage,
  disableBack = false,
  disableForward = false,
  pageCount = null,
}) => {
  return <div className="pagination-container">
    <p>
      {((currentPage - 1) * perPage) + 1} - {currentPage * perPage > count ? count : currentPage * perPage} de {count}
    </p>
    {pageCount !== null ? (
      <p data-testid="pagination-page">{`Página ${currentPage} de ${pageCount}`}</p>
    ) : null}
    <button
      type="button"
      onClick={goBack}
      disabled={disableBack}
      aria-label="Página anterior"
    >
      <i
        className="icon icon-width-24 icon-angle-left background-accent"
        aria-hidden={true}
      ></i>
    </button>
    <button
      type="button"
      onClick={goForward}
      disabled={disableForward}
      aria-label="Próxima página"
    >
      <i
        className="icon icon-width-24 icon-angle-right background-accent"
        aria-hidden={true}
      ></i>
    </button>
  </div>
}

export default Pagination
